import React from 'react';
import { Message } from '../types';

interface MessageBubbleProps {
  message: Message;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`flex w-full mb-4 sm:mb-8 ${isUser ? 'justify-end' : 'justify-start'} animate-in fade-in slide-in-from-bottom-6 duration-500`}>
      <div className={`max-w-[90%] sm:max-w-[85%] md:max-w-[70%] rounded-2xl sm:rounded-3xl px-4 sm:px-7 py-3 sm:py-5 shadow-2xl border relative ${
        isUser 
          ? 'bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 text-white rounded-tr-none border-white/20 shadow-blue-900/40' 
          : 'bg-slate-900/40 backdrop-blur-2xl text-slate-100 border-white/10 rounded-tl-none shadow-black/60'
      }`}>
        {isUser && (
          <div className="absolute inset-0 rounded-2xl sm:rounded-3xl rounded-tr-none bg-white/5 opacity-50 pointer-events-none"></div>
        )}
        <p className="text-base sm:text-[17px] leading-relaxed font-bold tracking-tight whitespace-pre-wrap selection:bg-cyan-500/30">
          {message.text}
        </p>
        <div className={`flex items-center mt-3 sm:mt-4 space-x-2 sm:space-x-3 opacity-40 ${isUser ? 'justify-end' : 'justify-start'}`}>
          <span className="text-[9px] sm:text-[10px] font-black uppercase tracking-[0.2em] sm:tracking-[0.3em]">
            {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
          {!isUser && (
            <div className="w-1 h-1 sm:w-1.5 sm:h-1.5 bg-cyan-400 rounded-full animate-pulse shadow-[0_0_8px_rgba(34,211,238,0.8)]"></div>
          )}
        </div>
      </div>
    </div>
  );
};
